const mutations = {
  getShowCases: (state, showcase) => {
    state.showcase = showcase;
  },
  getShowCase: (state, showcase_id) => {
    state.showcase_id = showcase_id;
  },
  getShowCaseAvailability: (state, showcase_availability) => {
    state.showcase_availability = showcase_availability;
  },
  postShowCase: (state, new_showcase) => {
    state.showcase.push(new_showcase);
  },
  updateShowCases: (state, new_status) => {
    state.showcase = state.showcase.map((showcase) => {
      if (showcase.id === new_status.showcase_id) {
        return Object.assign({}, showcase, new_status.status);
      }
      return showcase;
    });
  },
  putShowCase: (state, payload) => {
    state.showcase = state.showcase.map((showcase) => {
      if (showcase.showcase_id === payload.id) {
        return Object.assign({}, showcase, payload.formData);
      }
      return showcase;
    });
  },
  delShowCase(state, id) {
    const index = state.showcase.findIndex(showcase => showcase.showcase_id == id);
    state.showcase.splice(index, 1);
  },
};

export default mutations;
